import * as React from 'react'
import { FC, useEffect } from 'react'
import { useGetTubesQuery } from '../../../../../../../../../../store/api/tubes-api'
import { EndpointQueryParameters } from '../../../../../../../../../../types/strapi/strapi'
import { Form, Select } from 'antd'
import Tube from '../../../../../../../../../../types/api/tube'

interface TubesProps {
    tube?: Tube
}

const Tubes: FC<TubesProps> = ({ tube }) => {
    const name = 'tube'

    const tubesQueryParams: EndpointQueryParameters = {
        filters: {
            stamps: {
                $null: 'true',
            },
        },
        pagination: { pageSize: 5000, page: 1 },
        sort: ['number:desc'],
    }
    const { data, refetch, isLoading } = useGetTubesQuery(tubesQueryParams)

    let optionsData = data?.data.map(x => ({
        value: x.documentId,
        label: x.number,
    }))
    const firstElem = [{ value: '', label: 'Не выбрана' }]
    if (tube) {
        firstElem.push({ value: tube.documentId, label: `${tube.number} — текущая` })
    }

    useEffect(() => {
        refetch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Form.Item name={name} label={'Туба'}>
            <Select
                loading={isLoading}
                options={optionsData ? [...firstElem, ...optionsData] : firstElem}
            />
        </Form.Item>
    )
}

export default Tubes
